@if (canCreate()) {
<mat-toolbar>
  <span class="fill-remaining-space"></span>
  <span>
    <button
      mat-raised-button
      (click)="navCreateRecommendation()">
      Create Recommendation
    </button>
  </span>
</mat-toolbar>
}
<table
  mat-table
  matSort
  #recTableComp
  [dataSource]="recTable.data"
  class="mat-elevation-z8"
  aria-describedby="recommendations to audit">
  @if (!recTable.ready) {
  <h1>Loading...</h1>
  } @for (col of recTable.col; track col) { @if (!col.custom) {
  <ng-container [matColumnDef]="col.field">
    <th
      id="title"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      {{ col.title }}
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation[col.field] }}
    </td>
  </ng-container>
  } @if (col.custom === 'currentDeadlineDate') {
  <ng-container [matColumnDef]="col.field">
    <th
      id="deadline"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      {{ col.title }}
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      @if(col.field){
      {{ recommendation[col.field] | date : 'dd.MM.yyyy' : 'UTC' }}
      }
    </td>
  </ng-container>
  } @if (col.custom === 'name') {
  <ng-container [matColumnDef]="col.field">
    <th
      id="status"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      {{ col.title }}
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.assessmentCoordinator | userName: recommendation.assessmentCoordinatorName | async }}
      {{ recommendation.assessmentCoordinator | azureIdStatus | async }}
    </td>
  </ng-container>
  } @if (col.custom === 'createdOn') {
  <ng-container [matColumnDef]="col.field">
    <th
      id="created_on"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      {{ col.title }}
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.createdAt | date : 'dd.MM.yyyy' : 'UTC' }}
    </td>
  </ng-container>
  } }
  <tr
    mat-header-row
    *matHeaderRowDef="colFields(recTable.col)"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: colFields(recTable.col)"
    [routerLink]="['/recommendation_detail', row.id]"
    class="item"></tr>
</table>

<mat-paginator
  #recPaginator
  [pageSizeOptions]="[10, 25, 40]"
  showFirstLastButtons />
